import React from 'react';

const Grok4Launch = () => (
  <article className="news-article-body">
    <p className="news-lead">
      xAI's Grok series has rapidly advanced from a ChatGPT alternative to a genuine frontier
      reasoning model. Grok 3 launched in February 2025 on 200,000 H100 GPUs. By July 2025,
      Grok 4 became the first AI model to exceed 50% on the notoriously difficult
      Humanity's Last Exam (HLE) benchmark.
    </p>

    <h2>Grok 3 — February 2025</h2>
    <p>
      Elon Musk livestreamed the Grok 3 launch on February 17, 2025. The model was trained
      on xAI's Colossus supercomputer using <strong>200,000 NVIDIA H100 GPUs</strong> — roughly
      10–15× the compute used for Grok 2. Key benchmarks:
    </p>
    <ul>
      <li><strong>93.3%</strong> on AIME 2025 Mathematics</li>
      <li><strong>84.6%</strong> on GPQA (graduate-level science)</li>
      <li><strong>79.4%</strong> on code generation tasks</li>
      <li>Chatbot Arena Elo score of <strong>1402</strong></li>
    </ul>
    <p>
      Two variants shipped: standard Grok 3 and <strong>Grok 3 (Think)</strong>, which spends
      seconds to minutes reasoning through problems before responding — the same "extended
      thinking" pattern pioneered by OpenAI's o1 series.
    </p>

    <h2>Grok 4 — July 2025</h2>
    <p>
      Grok 4 crossed a threshold that had eluded all prior models: exceeding <strong>50%</strong>
      on the <em>Humanity's Last Exam (HLE)</em> — a curated set of extremely difficult questions
      from top human experts across mathematics, science, and philosophy that was designed to
      resist AI solution.
    </p>
    <ul>
      <li><strong>87.5%</strong> on GPQA Diamond</li>
      <li><strong>91.7%</strong> on AIME 2025</li>
      <li><strong>256K context window</strong> with native tool use and real-time search</li>
    </ul>
    <p>
      Grok 4 Heavy, a multi-agent variant, uses approximately <strong>10× more compute per query</strong>
      by running multiple model instances in parallel and aggregating their reasoning.
    </p>

    <h2>Beyond Grok 4: 2026 Iterations</h2>
    <div className="news-timeline">
      <div className="news-timeline-item">
        <span className="news-timeline-date">Grok 4.1 (Nov 2025)</span>
        <div>Hallucination rate dropped from ~12% to ~4% — a 65% improvement in factual reliability.</div>
      </div>
      <div className="news-timeline-item">
        <span className="news-timeline-date">Grok 4.20 Beta (Feb 2026)</span>
        <div>
          Native 4-agent architecture: Grok (coordinator), Harper (fact-verification),
          Benjamin (math/logic), and Lucas (creative). Debate-and-verify approach reduced
          hallucinations to 4.2%.
        </div>
      </div>
      <div className="news-timeline-item">
        <span className="news-timeline-date">Grok 4.20 Beta 2 (Mar 2026)</span>
        <div>Enhanced vision capabilities, multi-image rendering, and further accuracy improvements.</div>
      </div>
    </div>

    <h2>The Infrastructure Behind xAI</h2>
    <p>
      xAI's Colossus cluster in Memphis is one of the largest single-site GPU training facilities
      in the world. The scale of Grok 4's training compute — and the speed at which xAI expanded
      Colossus from 10K to 200K GPUs in under 12 months — signals how quickly private AI
      infrastructure can scale when capital is unconstrained.
    </p>

    <div className="news-insight-box">
      <h3>Key Takeaway</h3>
      <p>
        Grok 4's HLE breakthrough challenges the assumption that certain categories of expert
        knowledge are permanently AI-resistant. Multi-agent debate architectures may become
        the standard approach for high-stakes reasoning tasks where a single model pass
        is insufficient.
      </p>
    </div>
  </article>
);

export default Grok4Launch;
